import {
  fromJS
} from 'immutable';
import {
  handleActions
} from 'redux-actions';
import * as Types from '../actions/constants';

const INITIAL_STATE = fromJS({
  sidebar: false
});

const visibilityReducer = handleActions({
  [Types.TOGGLE_SIDEBAR]: (state, action) => {
    if (action.payload && action.payload.toggle) {
      return state.update('sidebar', (value) => action.payload.toggle);
    } else {
      return state.update('sidebar', (value) => !value);
    }
  }
}, INITIAL_STATE);


export default visibilityReducer;



// WEBPACK FOOTER //
// ./client/store/reducers/visibilityReducer.js